export default "__VITE_ASSET__BfU0OEYF__"